import { ObjectType } from '@/app/constants/typedef';
import { IUser, UserLevel, LevelInfo } from './IUser';
import { DateType } from '../date';
import { ImageObjectTypes } from '../avatar/avatar';

export type { UserLevel, LevelInfo };

class UserModel implements IUser {
    id: string;
    nickname: string;
    email?: string;
    contacts: any[];
    avatarUrl: ImageObjectTypes;
    phoneNumber?: string;
    isExpert: boolean;
    isGoogleLoggedIn?: boolean;
    isAppleLoggedIn?: boolean;
    isKakaoLoggedIn?: boolean;
    isNaverLoggedIn?: boolean;
    isInfluencer: boolean;
    isLeader?: boolean;
    isStaff: boolean;
    updatedAt: DateType;
    createdAt: DateType;
    level?: UserLevel;
    totalPoints?: number;
    provider?: string | null;
    kakaoId?: string | null;
    naverId?: string | null;
    isFollowing?: boolean;
    followersCount?: number;
    followingCount?: number;
    myroom?: { linked: boolean; owner_idstr: string | null; thumbnail_url: string | null };

    constructor(data: ObjectType) {
        this.id = data.id;
        this.nickname = data.nickname;
        this.email = data.email;
        this.contacts = data.contacts || [];
        this.isStaff = data.is_staff;
        this.isInfluencer = data.is_influencer;
        this.isLeader = data.is_leader;
        this.isExpert = data.is_expert;
        this.avatarUrl = data.avatar;
        this.phoneNumber = data.phone_number;
        this.isGoogleLoggedIn = data.is_google_logged_in;
        this.isAppleLoggedIn = data.is_apple_logged_in;
        this.isKakaoLoggedIn = data.is_kakao_logged_in;
        this.isNaverLoggedIn = data.is_naver_logged_in;
        this.updatedAt = data.updated_at;
        this.createdAt = data.created_at;
        this.level = data.level;
        this.totalPoints = data.level?.point;
        this.provider = data.provider || null;
        this.kakaoId = data.kakaoId || null;
        this.naverId = data.naverId || null;
        this.isFollowing = data.is_following || false;
        this.followersCount = data.followers_count || 0;
        this.followingCount = data.following_count || 0;
        this.myroom = data.myroom;
    }

    getUser(): UserModel {
        return this;
    }
}

export default UserModel;
